import { PurchasedImage } from "./styels/PurchasedImage.styeld";
import PrepareImg from "../../../../../../../image/prepare.jpg";

export default function PurchasedImg() {
  return <PurchasedImage src={PrepareImg} alt="상품" />;
}
